module.exports = __webpack_public_path__ + "static/media/20.716f99f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/20.png
// module id = 761
// module chunks = 0